import React from 'react'
import { DATA_SCIENCE_COURSES, QuizAttemptsDashboard } from './ProgrammingDashboard'

const DataScienceDashboard = () => (
  <QuizAttemptsDashboard courses={DATA_SCIENCE_COURSES} />
)

export default DataScienceDashboard
